import { useState } from "react";

const GoFaster = ({ GoFasterInfo }) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className="bg-[#292929] lg:pb-[142px] md:pb-[100px] sm:pb-[80px] pb-[60px]">
      <div className="custom-container py-[50px]">
        <div className="font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold border-b-[3px] border-[#ffff] text-[#7ABF5B]">
          {GoFasterInfo?.title}
        </div>

        <div className="flex flex-wrap">
          {GoFasterInfo?.list?.map((items, index) => {
            return (
              <div
                onClick={() => setActiveTab(index)}
                className={`${
                  activeTab == index ? "text-[#7ABF5B]" : "text-[#fff]"
                } cursor-pointer lg:mr-[60px] md:mr-[40px] mr-[10px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] lg:mt-[40px] mt-[20px] font-bold`}
              >
                <span
                  className={`${
                    activeTab == index
                      ? "underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B] pb-[16px]"
                      : ""
                  }`}
                >
                  {items}
                </span>
              </div>
            );
          })}
        </div>

        <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] mt-[45px]">
          {GoFasterInfo?.info?.[activeTab]}
        </div>
      </div>
    </div>
  );
};
export default GoFaster;
